import {
  getIsOperatorFromSelector,
  getQuotation,
  setQuestionsVisibility,
} from 'app/services/businessFunctionHelpers';
import {
  FieldsEnum,
  FormsEnum,
  RenewalChangedAddressEnum,
} from 'app/shared/enums';
import { addRenewalChangedAddress } from 'app/shared/helpers/addRenewalChangedAddress';

export const showAddressFieldsForRenewal = (
  initialRun: boolean,
  changedAddress: RenewalChangedAddressEnum
) => {
  const quotation = getQuotation();
  const isRenewal = !!(quotation.renewal || quotation.externalRenewal);
  const isOperator = getIsOperatorFromSelector();

  if (initialRun || !isRenewal || isOperator) return;

  addRenewalChangedAddress(initialRun, changedAddress);

  let fields: Array<FieldsEnum> = [];

  switch (changedAddress) {
    case RenewalChangedAddressEnum.OwnerLegal:
      fields = [
        FieldsEnum.OwnerLegalAddressStreetName,
        FieldsEnum.OwnerLegalAddressStreetNumber,
        FieldsEnum.OwnerLegalAddressApartmentNumber,
      ];
      break;
    case RenewalChangedAddressEnum.OwnerHome:
      fields = [
        FieldsEnum.OwnerHomeAddressStreetName,
        FieldsEnum.OwnerHomeAddressStreetNumber,
        FieldsEnum.OwnerHomeAddressApartmentNumber,
      ];
      break;
    case RenewalChangedAddressEnum.Coowner1Legal:
      fields = [
        FieldsEnum.Coowners1LegalAddressStreetName,
        FieldsEnum.Coowners1LegalAddressStreetNumber,
        FieldsEnum.Coowners1LegalAddressApartmentNumber,
      ];
      break;
    case RenewalChangedAddressEnum.Coowner2Legal:
      fields = [
        FieldsEnum.Coowners2LegalAddressStreetName,
        FieldsEnum.Coowners2LegalAddressStreetNumber,
        FieldsEnum.Coowners2LegalAddressApartmentNumber,
      ];
      break;
  }

  setQuestionsVisibility(fields, true, FormsEnum.CheckoutForm);
};
